import type { ActivityTimeseriesPoint } from "@/lib/api";

/**
 * Dependency-free bar chart of daily activity. Each column's height is that
 * day's total events; the blue portion (bottom) is the share that were logins,
 * with remaining events shown in warm gray. Red is reserved for brand/UI, never
 * for data fills — the segments use sanctioned accent + neutral tones. A
 * group-hover tooltip shows the exact counts.
 */
export function ActivityChart({ data }: { data: ActivityTimeseriesPoint[] }) {
  const max = Math.max(1, ...data.map((d) => d.events));

  return (
    <div className="flex h-40 items-stretch gap-1">
      {data.map((point) => {
        const heightPct = point.events ? Math.max(2, (point.events / max) * 100) : 0;
        const loginPct = point.events ? (point.logins / point.events) * 100 : 0;
        return (
          <div key={point.day} className="group relative flex flex-1 flex-col justify-end">
            <div
              className="bg-warm-gray-04 relative w-full overflow-hidden rounded-t"
              style={{ height: `${heightPct}%` }}
            >
              <div
                className="bg-jj-blue-03 absolute inset-x-0 bottom-0"
                style={{ height: `${loginPct}%` }}
              />
            </div>
            <span className="bg-foreground text-background pointer-events-none absolute -top-8 left-1/2 z-10 hidden -translate-x-1/2 rounded px-1.5 py-0.5 text-[10px] whitespace-nowrap tabular-nums group-hover:block">
              {point.day}: {point.events} events · {point.logins} logins
            </span>
          </div>
        );
      })}
    </div>
  );
}
